module.exports = __webpack_public_path__ + "img/baitian-erweima.d6115153.png";